/* THE BASICS – reveal sections on scroll */
(function () {
  var root = document.documentElement;
  if (root.classList.contains('shopify-design-mode')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var sections = document.querySelectorAll('#MainContent > .shopify-section:not(:first-child)');
  if (!sections.length) return;

  root.classList.add('basics-anim');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('basics-in');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  sections.forEach(function (section) { observer.observe(section); });

  // Safety net: never leave content hidden
  setTimeout(function () {
    sections.forEach(function (section) { section.classList.add('basics-in'); });
  }, 6000);
})();
